<template>
        <div id="print_food_order">
            <p style="font-size: 18px; font-weight: 600; color: #213665; font-family: Arial, Helvetica, sans-serif;">Food Order for: {{food_order_name }}</p>

            <table v-for="(preferProduct, index) in preferProducts" :key="index" cellpadding="0" cellspacing="0"  style="border: 1px solid #cacaca; border-collapse: collapse; width: 100%; font-family: Arial, Helvetica, sans-serif; color: #636363; margin-bottom: 20px;">
                <thead>
                <tr>
                    <td style="padding: 10px 20px; background-color: #38558e; color: #fff;">
                        <h2 style="margin: 0; padding: 0;">{{index}}</h2>
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <table cellpadding="0" cellspacing="0" style="border: 1px solid #cacaca; border-collapse: collapse; width: 100%; font-family: Arial, Helvetica, sans-serif; color: #636363;">
                            <thead style="background-color: #f4f4f4; border-bottom: 1px solid #cacaca;">
                                <tr>
                                    <!-- <th style="padding: 10px; font-size: 18px; text-align: center;">&nbsp;</th> -->
                                     
                                    <th style="padding: 10px; font-size: 18px; text-align: left; width: 20%;">PRODUCTS</th>
                                    <th style="padding: 10px; font-size: 18px; text-align: left;">DISTRIBUTOR</th>
                                    <th style="padding: 10px; font-size: 18px; text-align: center;">STUDENT COUNT</th>
                                    <th style="padding: 10px; font-size: 18px; text-align: left;">NEEDED</th>
                                    <th style="padding: 10px; font-size: 18px; text-align: center;">ON HAND</th>
                                    <th style="padding: 10px; font-size: 18px; text-align: left;">ESTIMATED NEEDED</th>
                                    <th style="padding: 10px; font-size: 18px; text-align: center;">CASE</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(preferProduct, product) in preferProduct " :key="product">
                                    <tr style="border-bottom: 1px solid #cacaca;" v-if="! preferProduct.ignored">
                                        <!-- <td style="padding: 10px; font-size: 16px; text-align: center;">
                                            <input type="checkbox" name="" id="">
                                        </td> -->
                                        <td style="padding: 10px; font-size: 16px; text-align: left; color: #0092d0; text-decoration: underline;" >  {{ preferProduct.name }}</td>

                                        <td style="padding: 10px; font-size: 16px; text-align: left;">
                                            <div class="relative focus:outline-none sm:w-60 w-50 xl:pl-4 pl-0 xl:mt-0 mt-4">
                                                <div v-for="(i, value)  in preferProduct.distributors">
                                                    <div v-if="i.id == preferProduct.distributor_id">
                                                        {{ i.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <td style="padding: 10px; font-size: 16px; text-align: center;">
                                            {{ preferProduct.student_count }}
                                        </td>
                                        <td style="padding: 10px; font-size: 16px; text-align: left;">
                                            {{formattedValue (preferProduct.needed_recipe_amount)}} {{ preferProduct.recipe_amount_uom }}
                                                <div v-if="preferProduct.not_convertable" class="absolute right-0 top-7">
                                                    <a target="_blank" :href="route('products_edit',{ id: preferProduct.product_id })">
                                                        <!-- <svg fill="#ffc919" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            width="14px" height="14px" viewBox="0 0 123.996 123.996"
                                                            xml:space="preserve">
                                                        <g>
                                                            <path d="M9.821,118.048h104.4c7.3,0,12-7.7,8.7-14.2l-52.2-92.5c-3.601-7.199-13.9-7.199-17.5,0l-52.2,92.5
                                                                C-2.179,110.348,2.521,118.048,9.821,118.048z M70.222,96.548c0,4.8-3.5,8.5-8.5,8.5s-8.5-3.7-8.5-8.5v-0.2c0-4.8,3.5-8.5,8.5-8.5
                                                                s8.5,3.7,8.5,8.5V96.548z M57.121,34.048h9.801c2.699,0,4.3,2.3,4,5.2l-4.301,37.6c-0.3,2.7-2.1,4.4-4.6,4.4s-4.3-1.7-4.6-4.4
                                                                l-4.301-37.6C52.821,36.348,54.422,34.048,57.121,34.048z"/>
                                                        </g>
                                                        </svg> -->

                                                        <svg width="16px" height="16px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42ZM24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44ZM25 28V12C25 11.4477 24.5523 11 24 11C23.4477 11 23 11.4477 23 12V28C23 28.5523 23.4477 29 24 29C24.5523 29 25 28.5523 25 28ZM24 9C22.3431 9 21 10.3431 21 12V28C21 29.6569 22.3431 31 24 31C25.6569 31 27 29.6569 27 28V12C27 10.3431 25.6569 9 24 9ZM24 37C23.4477 37 23 36.5523 23 36C23 35.4477 23.4477 35 24 35C24.5523 35 25 35.4477 25 36C25 36.5523 24.5523 37 24 37ZM21 36C21 34.3431 22.3431 33 24 33C25.6569 33 27 34.3431 27 36C27 37.6569 25.6569 39 24 39C22.3431 39 21 37.6569 21 36Z" fill="#333333"/>
                                                        </svg>
                                                    </a>
                                                </div>
                                        </td>
                                        <td style="padding: 10px; font-size: 16px; text-align: center;">{{ preferProduct.needed }}</td>
                                        <td style="padding: 10px; font-size: 16px; text-align: left;">
                                            {{ estimatedNeeded(preferProduct.needed_recipe_amount, preferProduct.needed) }}
                                            {{ preferProduct.recipe_amount_uom }}
                                        </td>
                                        <td style="padding: 10px; font-size: 16px; text-align: center;">                                    {{preferProduct.case_quantity}}
</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
</template>


    <script>
    import DefaultLayout from "@/Layouts/DefaultLayout";
    import Welcome from "@/Jetstream/Welcome";
    import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
    import PageTitleLayout from "@/Pages/Common/PageTitle";
    import TableFilterLayout from "@/Pages/Common/TableFilters";
    import TableIndexLayout from "@/Pages/Common/TableIndex";

    export default {
        data() {
            return {
                preferProducts:this.preferProducts,
            }
        },

        props: ['preferProducts', 'formattedValue', 'estimatedNeeded', 'food_order_name'],

        components: {
            DefaultLayout,
            Welcome,
            BreadcrumLayout,
            PageTitleLayout,
            TableFilterLayout,
            TableIndexLayout,
            distributorNotSelectCount: 0,

        },

        mounted(){
            console.log('preferProducts dsafsafsafsadl', this.preferProducts);
        },

    };
    </script>


    <style>
    .title::after,
    .title::before {
        content: '';
        position: absolute;
        right: 1.25em;
        top: 1.25em;
        width: 2px;
        height: 0.75em;
        background-color: #7A7572;
        transition: all 0.2s;
    }

    .content p {
        padding: 20px;
    }

    .min-height-third {
        min-height: 400px;
    }

    .span-text {
        font-size: 14px;
        color: #727272;
        padding-bottom: 5px;
    }

    .progress-bar>div {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        height: 23px;
        line-height: 23px;
    }

    .progress-text {
        font-size: 19px;
        color: #3f3f3f;
    }

    .progress-bar {
        background-color: #fff;
        border: 1px solid #cacaca;
        border-radius: 5px;
        height: 25px;
    }

    .bg-green-500 {
        background-color: #22af4b;
    }

    .sm\:text-sm {
        font-size: 0.850rem;
        line-height: 1.25rem;
    }

    .order-detail {
        color: #4a4a4a;
        font-size: 14px;
    }

    .w-52-rec {
        width: 13.2rem;
    }

    .cancel-button-color {
        background-color: #8b8b8b;
    }

    .input-background {
        background-color: #f8f8f8;
    }

    .text-base-heading {
        font-size: 14px;
    }

    .button-bg-color-wed-menu2-gray {
        border: none !important;
        min-height: 35px;
        min-width: 35px;
    }

    .menu1-background-color {
        background-color: #FAA43D;
    }

    .button-bg-color-wed-menu2 {
        background-color: #38558e;
        border: none !important;
        min-height: 35px;
        min-width: 35px;
    }

    .menu1-icon-color {
        color: #38558e;
    }

    .id-color-menu-edit {
        color: #F7A53A;
    }

    .bg-button-color {
        background-color: #cb0000;
    }

    .min-w-min-button {
        min-height: 26px;
        min-width: 53px;

    }

    .w-150 {
        width: 150px;
    }

    .max-w-0-menu1 {
        max-width: 4rem;
    }

    .bg-button-color-green {
        background-color: #22af4b;
    }

    .bg-button-color-gray {
        background-color: #636363;
    }

    .bg-hard-grey {
        background-color: #f4f4f4;
    }

    .font-size-edit {
        font-size: 10.5px;
    }

    .w-96-edit-recipes {
        width: 35rem;
    }

    .select-menu-height-edit2 {
        height: 2.8rem;
    }

    @media screen and (min-width: 1500px) {
        .id_arrow .fa-sort-desc:before {
            content: "\f0dd";
            position: absolute;
            top: 16px;
            left: 43px;
            padding-left: 7px;
            color: #219FD5;
        }

        .id_arrow .fa-sort-asc:before {
            content: "\f0de";
            color: #219FD5;
            padding-left: 7px;
            position: absolute;
            top: 16px;
            left: 43px;
        }
    }

    @media screen and (max-width: 1499px) {
        .id_arrow .fa-sort-asc:before {
            content: "\f0de";
            color: #219FD5;
            padding-left: 7px;
            position: absolute;
            top: 28px;
            left: 43px;
        }

        .id_arrow .fa-sort-desc:before {
            content: "\f0dd";
            position: absolute;
            top: 28px;
            left: 43px;
            padding-left: 7px;
            color: #219FD5;
        }
    }

    @media screen and (max-width: 1279px) {
        .searching-background-color {
            margin-left: 1.25rem;
            margin-right: 1.25rem;
        }

        .my_table {
            margin-left: 1.25rem;
            margin-right: 1.25rem;
        }

        .bottom_button {
            padding-right: 1.25rem;
            padding-left: 1.25rem;
        }
    }

    @media screen and (max-width: 570px) {

        .right-button,
        .order-detail {
            margin-top: 0.625rem;
        }
    }

    .validation_error_msg {
        font-weight: 400;
        margin: 6px 0 0 !important;
        color: red;
    }
    </style>
